<!-- <h2 ngpDialogTitle>{{objectActionTitle}}</h2> -->

<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="header-content">
      <fa-icon [icon]="objectActionIcon"></fa-icon>

      @switch (shareMode) { @case (ShareMode.SINGLE) {
      <!-- Single post share specific UI -->
      <h2 ngpDialogTitle>{{ "share-popup.title.share-post" | translate }}</h2>
      } @case (ShareMode.SELECTED) {
      <!-- UI elements for backend-resolved selected posts -->
      <h2 ngpDialogTitle>
        {{ "share-popup.title.share-selected-posts" | translate }}
      </h2>
      } @case (ShareMode.RESULTSET) {
      <!-- UI for resultset share -->
      <h2 ngpDialogTitle>
        {{ "share-popup.title.share-resultset" | translate }}
      </h2>
      } }
    </div>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="faTimes"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <app-export-settings
      [objectId]="objectId"
      [objectClassId]="objectClassId"
      [postIds]="postIds"
      [shareMode]="shareMode"
      [shareParams]="shareParams"
      #exportSettings
      (exportFormatChanged)="exportFormatChanged($event)"
      (exportSettingsChanged)="exportSettingsChanged($event)"
      (isDirtyChange)="handleIsDirtyChange($event)"
      (isValidChange)="handleIsValidChange($event)"
    ></app-export-settings>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ 'btn.cancel' | translate }}
    </sui-button>

    <sui-button
      variant="primary"
      [leadingIcon]="submitButtonIcon"
      [disabled]="!isValid()"
      (click)="share()"
    >
      {{ submitButtonText }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
